'use client';

import * as layout from '@ocodelib/compose-layout';
import { useEffect, useRef, useState } from 'react';
import { JsBasicAppProvider } from './JsBasicAppProvider';
import { buildLayout } from './layout/build-layout';
import { LayoutRoot } from './layout/LayoutRoot';
import type { IAppConfig, IJsBasicLayoutConfig, JsBasicAppType } from './types';

interface Props {
  appConfig: IAppConfig;
  onLayoutBuild?: (layoutManager: layout.ComposeLayoutManager) => void;
  onLoadApp?: (app: JsBasicAppType | null) => void;
}

export function JsBasicAppUi(props: Props) {
  const { appConfig, onLoadApp } = props;
  const onLayoutBuildRef = useRef(props.onLayoutBuild);
  onLayoutBuildRef.current = props.onLayoutBuild;

  const [appInfo, setAppInfo] = useState<{
    layoutManager: layout.ComposeLayoutManager;
    layoutConfig: IJsBasicLayoutConfig;
  }>();

  useEffect(() => {
    const { dispose, result } = buildLayout(onLayoutBuildRef.current);
    setAppInfo(result);
    return () => {
      dispose();
      setAppInfo(undefined);
    };
  }, []);

  if (!appInfo) {
    return null;
  }

  return (
    <layout.ComposeLayout layoutManager={appInfo.layoutManager}>
      <JsBasicAppProvider
        layoutConfig={appInfo.layoutConfig}
        appConfig={appConfig}
        onLoadApp={onLoadApp}
      >
        <LayoutRoot className="JsBasicAppUi-root" />
      </JsBasicAppProvider>
    </layout.ComposeLayout>
  );
}
